import { useEffect, useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField, SelectField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';
import { RootState } from '../../../store';
import { useSelector } from 'react-redux';

const AddTaxonomy = ({ data }: any) => {
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad, projectList } = data;
    const { authProject } = useSelector((state: RootState) => state.auth);
    const defaultFormObj = {
        id: selectedItem.id ? selectedItem.id : null,
        name: selectedItem.name ? selectedItem.name : "",
        code: selectedItem.code ? selectedItem.code :"",
        taxonomyTypeId: selectedItem.taxonomyType && selectedItem.taxonomyType.id ? selectedItem.taxonomyType.id  : null,
        projectId: selectedItem.projectId ? selectedItem.projectId : authProject.id,
        parentId: selectedItem?.parents?.length > 0 ? selectedItem.parents[selectedItem.parents.length - 1].parentId :  null
    };
    const [formField, setFormField] = useState(defaultFormObj);
    const [taxonomyTypeList, setTaxonomyTypeList] = useState([] as any);
    const [taxonomyListL1, setTaxonomyListL1] = useState([] as any);
    const [taxonomyListL2, setTaxonomyListL2] = useState([] as any);
    const [taxonomyListL3, setTaxonomyListL3] = useState([] as any);
    const [selectedTaxonomyL1, setSelectedTaxonomyL1] = useState<number | null>(null);
    const [selectedTaxonomyL2, setSelectedTaxonomyL2] = useState<number | null>(null);
    const [selectedTaxonomyL3, setSelectedTaxonomyL3] = useState<number | null>(null);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value ? value : null
        });
        if (name == 'taxonomyTypeId') {
            if (value){
                getTaxonomyByProjectAndTaxonomyType(Number(value));
            } else {
                setTaxonomyListL1([]);
            }
        }
    };

    const handleTaxonomyL1Change = (event: any) => {
        const { name, value } = event.target;
        if (value) {
            getTaxonomyByParentId('L2', Number(value));
        }
        setSelectedTaxonomyL1(value ? Number(value) : null);
        setSelectedTaxonomyL2(null);
        setSelectedTaxonomyL3(null);
        setFormField({
            ...formField,
            parentId: value ? value : null
        });
    };

    const handleTaxonomyL2Change = (event: any) => {
        const { name, value } = event.target;
        if (value) {
            getTaxonomyByParentId('L3', Number(value));
        }
        setSelectedTaxonomyL2(value ? Number(value) : null);
        setSelectedTaxonomyL3(null);
        setFormField({
            ...formField,
            parentId: value ? value : selectedTaxonomyL1
        });
    };

    const handleTaxonomyL3Change = (event: any) => {
        const { name, value } = event.target;
        setSelectedTaxonomyL3(value ? Number(event.target.value) : null);
        setFormField({
            ...formField,
            parentId: value ? value : selectedTaxonomyL2
        });
    };

    const isValidInput = (formObj: any) => {
        if (!formObj.projectId) {
            Toast('Please select project', "error");
            return false;
        }
        if (!formObj.taxonomyTypeId) {
            Toast('Please select dimensions', "error");
            return false;
        }
        if (!formObj.name || !formObj.name.trim()) {
            Toast('Please enter taxonomy name', "error");
            return false;
        }
        if (!/[A-Za-z]/.test(formObj.name)) {
            Toast('Taxonomy name cannot contain numbers and special characters only, Please enter a valid name', "error");
            return false;
        }
        if (!formObj.code || !formObj.code.trim()) {
            Toast('Please enter taxonomy code', "error");
            return false;
        }
        return true;
    }

    const handleAddTaxonomy = () => {
        if (!isValidInput(formField)) return;
        HttpService.postRequest(API_URL.ADD_TAXONOMY, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? 'Taxonomy updated successfully.' :  'Taxonomy added successfully.', "success");
                setIsOpenAddEdit(false);
                setIsLoad(true);
            },
            (err: any) => {
                Toast(err.message, "error");
            }
        )
    }

    const getTaxonomyByParentId = (level: string, id: number) => {
        HttpService.getRequest(`${API_URL.GET_TAXONOMY_BY_PARENT_ID}/${id}`).then(
            (res: any) => {
                if (level === 'L2') {
                    setTaxonomyListL2(res);
                }   else if (level === 'L3') {
                    setTaxonomyListL3(res);
                }
            },
            (err: any) => {
                if (level === 'L2') {
                    setTaxonomyListL2([]);
                } else if (level === 'L3') {
                    setTaxonomyListL3([]);
                }
                Toast(err.message, "error")
            },
        )
    }

    const getTaxonomyByProjectAndTaxonomyType = (tId: number) => {
        HttpService.getRequest(`${API_URL.GET_TAXONOMY_BY_PROJECT_AND_TAXONOMY_TYPE}/${selectedItem.projectId}?taxonomyTypeId=${tId}`).then(
            (res: any) => {
                setTaxonomyListL1(res);
            },
            (err: any) => {
                setTaxonomyListL1([]);
                Toast(err.message, "error")
            },
        )
    }

    const getTaxonomyType = () => {
        HttpService.getRequest(`${API_URL.GET_TAXONOMY_TYPE_BY_PROJECT_ID}/${authProject.id}`).then(
        (res: any) => {
            setTaxonomyTypeList(res ? res : []);
        },
        (err: any) => {
            Toast(err.message, "error")
        },
        )
    }

    const generateCode = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter taxonomy name', "error");
            return false;
        }
        let payLoadString = '';
        if (selectedTaxonomyL1) {
            const result = taxonomyListL1.find((item: any) => item.id === selectedTaxonomyL1);
            payLoadString = `${payLoadString} ${result.name}`;
        }
        if (selectedTaxonomyL2) {
            const result = taxonomyListL2.find((item: any) => item.id === selectedTaxonomyL2);
            payLoadString = `${payLoadString} ${result.name}`;
        }
        if (selectedTaxonomyL3) {
            const result = taxonomyListL3.find((item: any) => item.id === selectedTaxonomyL3);
            payLoadString = `${payLoadString} ${result.name}`;
        }
        payLoadString = `${payLoadString} ${formField.name}`;
        HttpService.postRequest(API_URL.GENERATE_CODE, payLoadString).then(
            (res: any) => {
                setFormField({
                    ...formField,
                    code: res ? res : null
                });
            }
        ).catch((err: any) => {
            Toast(err.message, "error");
        });
    }

    useEffect(() => {
        if (authProject && authProject.id) {
            getTaxonomyType();
        }
    }, []);

    useEffect(() => {
        if (authProject && authProject.id) {
            getTaxonomyType();
        }
        if (selectedItem) {
            if (selectedItem.taxonomyType && selectedItem.taxonomyType.id) {
                getTaxonomyByProjectAndTaxonomyType(selectedItem.taxonomyType.id);
            }
            if (selectedItem.parents && selectedItem.parents.length > 0) {
                selectedItem.parents.forEach((item: any) => {
                    if(item.level == '1') {
                        setSelectedTaxonomyL1(item.id);
                        getTaxonomyByParentId('L2', item.id);
                    }
                    if(item.level == '2') {
                        setSelectedTaxonomyL2(item.id);
                        getTaxonomyByParentId('L3', item.id);
                    }
                });
            }
        }
    }, []);

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-addtaxonomy'}
                srDescribedBy={'modal-id-addtaxonomy'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-addtaxonomy'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Taxonomy' : 'Add Taxonomy'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-addtaxonomy">
                    <div className='wk-grid-page-container p-0'>
                        <div className="wk-grid mt-10">
                            <div className="wk-column-12">
                                <SelectField size={'small'} label="Project" labelFor="select-id-project" indicator="required" isDisabled>
                                    <select id="select-id-project" name="projectId" value={formField.projectId || ''}
                                        onChange={(event: any) => handleInputChange(event)}>
                                        <option value="" disabled>-- Select Project --</option>
                                        {projectList.map((item: any, i: number) => (
                                            <option disabled value={item.id} key={i}>{item.name}</option>
                                        ))}
                                    </select>
                                </SelectField>
                                <SelectField size={'small'} label="Dimensions" labelFor="select-id-taxonomytype" indicator="required">
                                    <select id="select-id-taxonomytype" name="taxonomyTypeId" value={formField.taxonomyTypeId || ''}
                                        onChange={(event: any) => handleInputChange(event)}>
                                        <option value="" disabled>-- Select Dimension --</option>
                                        {taxonomyTypeList.map((item: any, i: number) => (
                                            <option value={item.id} key={i}>{item.name}</option>
                                        ))}
                                    </select>
                                </SelectField>
                                <SelectField size={'small'} label="Taxonomy (L1)" labelFor="select-id-taxonomy-l1">
                                    <select id="select-id-taxonomy-l1" name="L1" value={selectedTaxonomyL1 || ''}
                                        onChange={(event: any) => handleTaxonomyL1Change(event)}>
                                        <option value="">-- Select Taxonomy (L1) --</option>
                                        {taxonomyListL1.map((item: any, i: number) => {
                                            if (selectedItem?.id !== item.id) {
                                                return (
                                                    <option value={item.id} key={i}>{item.name}</option>
                                                );
                                            }
                                            return null;
                                        })}
                                    </select>
                                </SelectField>
                                {selectedTaxonomyL1 && (
                                    <SelectField size={'small'} label="Taxonomy (L2)" labelFor="select-id-taxonomy-l2">
                                        <select id="select-id-taxonomy-l2" name="L2" value={selectedTaxonomyL2 || ''}
                                            onChange={(event: any) => handleTaxonomyL2Change(event)}>
                                            <option value="">-- Select Taxonomy (L2) --</option>
                                            {taxonomyListL2.map((item: any, i: number) => {
                                                if (selectedItem?.id !== item.id) {
                                                    return (
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </select>
                                    </SelectField>
                                )}
                                {selectedTaxonomyL2 && (
                                    <SelectField size={'small'} label="Taxonomy (L3)" labelFor="select-id-taxonomy-l3">
                                        <select id="select-id-taxonomy-l3" name="L3" value={selectedTaxonomyL3 || ''}
                                            onChange={(event: any) => handleTaxonomyL3Change(event)}>
                                            <option value="">-- Select Taxonomy (L3) --</option>
                                            {taxonomyListL3.map((item: any, i: number) => {
                                                if (selectedItem?.id !== item.id) {
                                                    return (
                                                        <option value={item.id} key={i}>{item.name}</option>
                                                    );
                                                }
                                                return null;
                                            })}
                                        </select>
                                    </SelectField>
                                )}
                                <div className='custom-field-mb-5'>
                                    <InputField label="Name" labelFor="taxonomy-name-1" size="small" indicator="required">
                                        <input
                                            type="text" id="taxonomy-name-1" name="name"
                                            placeholder="Taxonomy Name"
                                            onChange={(event: any) => handleInputChange(event)}
                                            value={formField.name} autoComplete="off"
                                        />
                                    </InputField>
                                </div>
                                <div className="cg-field-header">
                                    <label className="cg-field-label pt-15">Code <div className="cg-field-required-indicator"><span aria-hidden="true">*</span><div data-e2e="cg-sr-only" className="cg-sr-only">Required field</div></div></label>
                                    <div className="pt-5">
                                        <button type="button" className="border border-primary btn btn btn-outline-light text-bg-light"
                                            style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                            onClick={generateCode}>
                                            Generate Code
                                        </button>
                                    </div>
                                </div>
                                <InputField label="" labelFor="taxonomy-code-1" size="small" indicator="required">
                                    <input
                                        type="text" id="taxonomy-code-1" name="code"
                                        placeholder="Taxonomy Code"
                                        readOnly={!formField.code}
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.code} autoComplete="off"
                                    />
                                </InputField>

                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} iconPosition={'left'}>
                                <button
                                    className='mr-10'
                                    type="button"
                                    id="save"
                                    onClick={handleAddTaxonomy}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddTaxonomy;